import makeAnimated from "react-select/animated";

export const animatedComponents = makeAnimated();

export interface GithubProps  {
    setLoading: (b: boolean) => void;
};


export interface IGithub {
    error?: string;
    repos: IRepo[];
    secrets: ISecret[];
    costCenter: string
}

export interface IRepo {
    id: number;
    name: string;
    updated_at: string;
    description?: string;
    topics?: string[];
}

export interface ISecret {
    name: string;
    created_at: string;
    updated_at: string;
    visibility: string;
    selectedRepos?: IRepo[];
    selected_repositories_url?: string;
}

export interface ITeam {
    name: string;
    slug: string;
}